export const refreshTokenEventEmitter = typeof window !== "undefined" && window.EventTarget ? new EventTarget() : {
  addEventListener: () => {},
  removeEventListener: () => {},
  dispatchEvent: () => {},
};



